import RestResource from '../rest.service';

export default class EmergenceService extends RestResource {
  map(payload) {
    return {
      plants_density: payload.plantsDensity,
      plants_per_meter: payload.plantsPerMeter,
      phosphate_fertilization: payload.phosphateFertilization,
      nitrogen_fertilization: payload.nitrogenFertilization,
      fertilization_dosis: payload.fertilizationDosis,
      seed_date: payload.seedDate,
      weed_control: payload.weedControl,
      pest_control: payload.pestControl,
      plot_id: payload.plotId,
      hail_storms: payload.hailStorms,
      rainfall: payload.rainfall,
      average_temperature: payload.averageTemperature,
      heat_strokes: payload.heatStrokes,
      frost: payload.frost,
      tizon: payload.tizon,
      helminthosporium: payload.helminthosporium,
      roya: payload.roya,
      corn_streak: payload.cornStreak,
      comment: payload.comment,
    };
  }

  mapAttach(payload) {
    return {
      pictures: payload,
    };
  }

  constructor() {
    super('emergences');
  }
}
